import { useAuthenticationContext } from '@/app/AuthenticationContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useProfile } from '@/hooks';
import { getSessionTokens } from '@/services/auth/authentication';
import { AI } from '@e2n/ai';

const getAccessToken = async () =>
  (await getSessionTokens())?.accessToken.toString();

// Must be rendered below AuthorizedPage since useStandortContext needs StandortContextProvider.
export function AIChat() {
  const { userInfo } = useAuthenticationContext();
  const { currentStandort } = useStandortContext();
  const { manager } = useProfile();

  return (
    <AI
      getAccessToken={getAccessToken}
      user={
        userInfo && {
          id: userInfo.id,
          username: userInfo.username,
          firstName: manager?.vorname,
        }
      }
      standort={{ id: currentStandort.id, name: currentStandort.name }}
    />
  );
}
